<template>
  <div>
    <div id="month-report-printable-area" class="section-cashcalc endday px-2" v-if="summary">
      <h2 class="ttl2 popup-header">{{ $gettext('Month report') }} - {{ monthYear }}</h2>
      <div class="text-center">{{ $gettext('Location') }}: <b>{{ summary.location }}</b></div>
      <div class="row">
        <div class="col-md-7 pr-md-0">
          <table class="table table-border-outline">
            <thead class="thead-light">
            <tr class="text-uppercase">
              <th class="text-left" v-translate>bill</th>
              <th v-translate>amount</th>
              <th v-translate>cash</th>
              <th v-translate>credit</th>
              <th v-translate>other</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-left">
                <span v-translate>Close</span>
                ({{ summary.bills[1].count }})</td>
              <td>{{ summary.bills[1].amount | currency }}</td>
              <td>{{ summary.bills[1].cash | currency }}</td>
              <td>{{ summary.bills[1].card | currency }}</td>
              <td>{{ summary.bills[1].other | currency }}</td>
            </tr>
            <tr class="border-bottom">
              <td class="text-left"> <span v-translate>Open</span> ({{ summary.bills[0].count }})</td>
              <td>{{ summary.bills[0].amount | currency }}</td>
              <td>--</td>
              <td>--</td>
              <td>--</td>
            </tr>
            <tr class="border-bottom">
              <td class="text-left"> <span v-translate>Void</span> ({{ summary.bills[2].count }})</td>
              <td>{{ summary.bills[2].amount | currency }}</td>
              <td>--</td>
              <td>--</td>
              <td>--</td>
            </tr>
            </tbody>
          </table>
          <table class="table table-border-outline do-payment-table" style="table-layout: auto;">
            <thead class="thead-light">
            <tr class="text-uppercase">
              <th class="text-left" v-translate>tax / charges</th>
              <th v-translate>amount</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(value, charge) in summary.chargeData" >
              <td>{{ charge }}</td>
              <td>{{ value | currency }}</td>
            </tr>
            </tbody>
          </table>
          <table class="table table-border-outline do-payment-table" style="table-layout: auto;">
            <thead class="thead-light">
            <tr class="text-uppercase">
              <th class="text-left" v-translate>do payment</th>
              <th v-translate>amount</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(group, groupIndex) in tablePayment">
              <tr @click="group.open = !group.open" :class="{ opened: group.open == true }" class="tr-parent">
                <td>
                  <span class="icon-expanded"></span>
                  <span>{{ group.name }} ({{ group.payments.length }})</span>
                </td>
                <td>{{ group.total | currency }}</td>
              </tr>
              <tr v-show="group.open" v-for="(payment, paymentIndex) in group.payments" class="tr-child">
                <template>
                  <td >{{ payment.expenseCategoryName }} - {{ payment.note }}</td>
                  <td>{{ payment.amount | currency }}</td>
                </template>
              </tr>
            </template>
            </tbody>
          </table>
          <table class="table table-border-outline do-payment-table" style="table-layout: auto;">
            <thead class="thead-light">
            <tr class="text-uppercase">
              <th class="text-left" v-translate>Commission</th>
              <th v-translate>amount</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="commission in tableCommission">
              <tr @click="commission.open = !commission.open" :class="{ opened: commission.open == true }" class="tr-parent">
                <td>
                  <span class="icon-expanded"></span>
                  <span>{{ commission.name }} ({{ commission.payments.length }})</span>
                </td>
                <td>{{ commission.total | currency }}</td>
              </tr>
              <tr v-show="commission.open" v-for="com in commission.payments" class="tr-child">
                <template>
                  <td ><translate>Staff</translate> #{{ com.note }}</td>
                  <td>{{ com.amount | currency }}</td>
                </template>
              </tr>
            </template>
            </tbody>
          </table>
          <table class="table table-border-outline do-payment-table" style="table-layout: auto;">
            <thead class="thead-light">
            <tr class="text-uppercase">
              <th class="text-left" v-translate>discount</th>
              <th v-translate>amount</th>
            </tr>
            </thead>
            <tbody>
            <tr class="tr-parent">
              <td>
                <span>Credited back line value</span>
              </td>
              <td>{{ summary.overall['Credited back line value'] | currency }}</td>
            </tr>
            <tr class="tr-parent">
              <td>
                <span>Promotions value (discount value)	</span>
              </td>
              <td>{{ summary.overall['Promotion(discount) value'] | currency }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-5">
          <table class="table table-shift-report">
            <tbody>
            <tr>
              <td v-translate>Sales result</td>
              <td>{{ summary.bills[1].amount | currency }}</td>
            </tr>
            <tr>
              <td v-translate>Payments (money-in)</td>
              <td>{{ summary.overall['Payments(money-in)'] | currency }}</td>
            </tr>
            <tr>
              <td v-translate>Payments (money-out)</td>
              <td>{{ summary.overall['Payments(money-out)'] | currency }}</td>
            </tr>
            <tr>
              <td v-translate>Commissions Paid</td>
              <td>{{ summary.overall['Commission paid'] | currency }}</td>
            </tr>

            <tr class="bg-hightlight">
              <td v-translate>Total</td>
              <td>{{ summary.overall['Total day'] | currency }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DayService from '@/services/DayService';
import { SET_CONFIRM_MODAL } from '@/store/mutation-types';
import { mapState } from 'vuex';

export default {
  name: 'MonthReport',
  data() {
    return {
      summary: null,
      tablePayment: [],
      tableCommission: [],
      month: ''
    };
  },
  computed: {
    ...mapState({
      workDay: state => state.auth.user.workDay,
    }),
    monthYear() {
      return this.$dayjs(this.month).format('YYYY-MM');
    },
  },
  methods: {
    async print() {
      const report = await this.$store.dispatch(
        'createPdf',
        {
          element: document.getElementById('month-report-printable-area'),
          reportType: 'monthReport',
          startTime: this.$dayjs(this.month),
        },
      );
      const data = await DayService.printMonthReport({
                            summary: JSON.stringify(this.summary), 
                            pdf: report.file,
                            message: report.message,
                            fileName: report.name
                          });
      this.summary = null;
      if (data) {
        await this.$store.dispatch('print', data);
        await report.pdf.save(report.name, { returnPromise: true });
      }
    },
    async getMonthReport(startTime = null, endTime = null) {
      let force = false;
      if(!startTime) {
        startTime = this.$dayjs(this.workDay.startTime).format('YYYY-MM-DD');
      } else {
        force = true;
      }
      if(!endTime) {
        endTime = this.$dayjs().format('YYYY-MM-DD');
      }
      const summary = await DayService.getMonthReport({ startTime, endTime, force });
      if (summary.length === 0) return;
      if (summary) {
        this.month = summary.monthYear;
        this.summary = summary;
        this.tablePayment = [
          {
            name: this.$gettext('Money-in'),
            payments: this.summary.moneyIns,
            total: this.summary.moneyIns.reduce((sum, payment) => sum + payment.amount, 0),
            open: true,
          },
          {
            name: this.$gettext('Money-out'),
            payments: this.summary.moneyOuts,
            total: this.summary.moneyOuts.reduce((sum, payment) => sum + payment.amount, 0),
            open: true,
          },
        ];
        this.tableCommission = [
          {
            name: this.$gettext('Earned Commission'),
            payments: this.summary.commissionList,
            total: this.summary.commissionList.reduce((sum, payment) => sum + payment.amount, 0),
            open: true,
          },
          {
            name: this.$gettext('Paid Commission'),
            payments: this.summary.payCommissions,
            total: this.summary.payCommissions.reduce((sum, payment) => sum + payment.amount, 0),
            open: true,
          },
        ];
        this.$nextTick(() => {
          this.print();
        });
      }
    },
  },
};
</script>
